import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import SlideshowBodyPreview from "./SlideshowBodyPreview";
import PiPopupWindowStaticTitle from "../components/PiPopupWindowStaticTitle";

export default function SlideshowPreview() {
  const title = <PiPopupWindowStaticTitle title={"Slideshow Quiz"} />;

  return <PiPopupWindowPreview body={<SlideshowBodyPreview />} title={title} />;
}
